module.exports = __webpack_public_path__ + "assets/img/checked2-d11bc6f4.png";